import axiosConfig from "../axiosConfig.js";

class LocationService {
    

    getCurrentLocation = async () => {
        fetch('http://ip-api.com/json/')
            .then((response) => response.json())
            .then((data) => {
               return data;
            })
            .catch((error) => console.error("Error fetching IP/location data:", error));
    }
}

const instance = new LocationService();

export default instance;
